module.exports = __webpack_public_path__ + "static/safety-badge-c06a0c3bfdee1211f815c93731c063a0.jpg";